import {Col, Row, Select, Tag} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import menuMultiSelectionFetcherHoc from "@hocs/menuMultiSelectionFetcherHoc";
import {Menu} from "@models/menu";
import clsx from "clsx";

const Option = Select.Option;

export interface MenuMultiSelectionReturnValue {
    new_menus: string[];
    deleted_menus: string[];
}

export const menuMultiSelectionDefaultReturnValue: MenuMultiSelectionReturnValue = {
    new_menus: [],
    deleted_menus: []
};

type MenuSelectionProps = {
    mode: SelectionMode,
    onChange: (value: MenuMultiSelectionReturnValue) => void
    selectedMenus: Menu[],
    data: Menu[],
    onScroll: (e: SyntheticEvent) => void,
    handleSearch: (query: string) => void,
    filter?: object,
    onFocus: () => void
}


/**
 * This class handle multi selection of menus
 * Use Select from ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted menus
 * @param props
 * @constructor
 */
const MenuMultiSelection: React.FC<MenuSelectionProps> = props => {
    const {handleSearch, onScroll, data = [], selectedMenus, onChange, onFocus} = props;
    const [selectedItems, setSelectedItems] = useState(selectedMenus);
    const [returnValue, setReturnValue] = useState<MenuMultiSelectionReturnValue>(menuMultiSelectionDefaultReturnValue);

    useEffect(() => {
        setSelectedItems(selectedMenus);
    }, [selectedMenus]);

    useEffect(() => {
        onChange(returnValue);
    }, [returnValue]);


    /**
     * if the deleted menu is assigned before should add to deleted menu
     * else it is enough to remove it from new menu
     * @param menu_id
     */
    const handleDelete = (menu_id: string): void => {
        const is_selected_before = selectedMenus.find(item => item.id == menu_id);

        if (is_selected_before) {
            setReturnValue({
                ...returnValue,
                deleted_menus: [...returnValue.deleted_menus, menu_id]
            })
        } else {
            setReturnValue({
                ...returnValue,
                new_menus: returnValue.new_menus.filter(id => id != menu_id)
            })
        }
        setSelectedItems(selectedItems.filter(item => item.id != menu_id));
    };

    /**
     * check if a new added menu is deleted before
     */
    const handleAdd = (menu_id, option) => {
        const isSelectedBefore = selectedItems.find(item => item.id == menu_id) ? true : false;
        if (!isSelectedBefore) {
            setReturnValue({
                deleted_menus: returnValue.deleted_menus.filter(id => id != menu_id),
                new_menus: [...returnValue.new_menus, menu_id]
            });
            setSelectedItems([...selectedItems, option.props.menu]);
        }
    };

    return (
        <Row gutter={24} className={`selected-with-add-btn`}>
            <Col span={24} className={`selection-input-wrapper`}>
                <Select
                    showSearch
                    mode={SelectionMode.MULTIPLE}
                    value={[]}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={false}
                    onSelect={handleAdd}
                    onFocus={onFocus}
                    onSearch={handleSearch}
                    onPopupScroll={onScroll}
                    notFoundContent={null}
                >
                    {data.map((menuItem, index) =>
                        <Option className={clsx({
                            "selected": selectedItems.find(item => item.id == menuItem.id)
                        })} value={menuItem.id} key={`menu_${index}`} menu={menuItem}>{menuItem.title}</Option>
                    )}
                </Select>
            </Col>
            <Col span={24} className={'selected-items-badge-list'}>
                {selectedItems.map(menu => (
                    <Tag key={menu.id} closable={true} onClose={() => handleDelete(menu.id)}>
                        {menu.title}
                    </Tag>
                ))}
            </Col>
        </Row>
    );
};

export default menuMultiSelectionFetcherHoc(MenuMultiSelection);


